import {
  accessInSgAndAu,
  accessInSgAndAuAndCA,
  accessInUS,
  accessInAU,
  accessInSG,
  accessExcludeSG,
  accessInCA,
  accessInUK,
} from './ec-constant';
import { EcEnv } from './ec-env';

export const enableO2O = accessInSgAndAu;
export const enableCAPI = accessInSgAndAuAndCA;
export const enableZipCode = accessExcludeSG;
export const enableMulberry = (accessInUS || accessInCA) && EcEnv.NEXT_PUBLIC_MULBERRY_PUBLIC_TOKEN;
export const enableBranch = accessInSgAndAu;
export const enablePinterest = accessInAU;
export const enableRetail = accessInSgAndAu;
export const enableShowroom = accessInAU;
export const enableWebHasShowroom = accessInAU || accessInSG || accessInUS || accessInCA;
export const enableSgStudios = accessInSG;
export const enableAuStudios = accessInAU;
export const enableBlackOut = accessInAU;
export const enableYotpo = EcEnv.NEXT_PUBLIC_YOTPO_ENABLED;
export const enableQuotation = accessInUS || accessInAU || accessInSG;
export const enableQuotationSevenDays = accessInUS || accessInAU;
// export const enableNewPromotion = accessInSG || accessInCA;
export const showApartmentBeforeStreet = accessInUK;
export const enabledNewPromotion = accessInCA || accessInSG || accessInUS || accessInAU || accessInUK;
export const enableGuarantee = accessInUK;
export const enableDisplayProductShipping = accessInAU || accessInUS || accessInCA || accessInUK;
export const enableWarehouseFrom = accessInSG || accessInAU || accessInUS || accessInCA;
export const enablePostcode = accessInAU || accessInUK;
export const enablePrivacyPolicy = accessInSG || accessInAU || accessInCA || accessInUK;
export const enableSpecificPrivacyPolicy = accessInCA || accessInUK;
export const enableAlert = accessInUS || accessInCA || accessInUK;
export const enableTermsOfUse = accessInUS;
